import { render, staticRenderFns } from "./Screenshot.vue?vue&type=template&id=74e29c2e&"
import script from "./Screenshot.vue?vue&type=script&lang=js&"
export * from "./Screenshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports